// Function loadWoolLabInteractiveMoodboardBlock loads the WoolLabInteractiveMoodboardBlock class by dynamically importing the js on demand if needed

export function loadWoolLabInteractiveMoodboardBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-favourites-block-chunk" */ '../widgets/woolLabInteractiveMoodboardBlock').then(wg => {

		const { WoolLabInteractiveMoodboardBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabInteractiveMoodboardBlock"]');

		if(!$wg) {
			// console.info('WoolLabInteractiveMoodboardBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabInteractiveMoodboardBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabInteractiveMoodboardBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabInteractiveMoodboardBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabInteractiveMoodboardBlock widget');

}
